import React from 'react';

interface PlanConfirmationDescriptionProps {
  prefix: string;
  emphasis: string;
  middle?: string;
  suffix: string;
}

// Translation fragments own spacing so Chinese and English use their own boundaries.
export function PlanConfirmationDescription({
  prefix,
  emphasis,
  middle,
  suffix,
}: PlanConfirmationDescriptionProps) {
  return <>{prefix}<strong className="text-text-main">{emphasis}</strong>{middle}{suffix}</>;
}
